import React from 'react';
import './index.css';
import section2img from "../assests/HomeImg/section2-img.svg";

const LocationIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#84CC16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 21C16 17 20 13.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 13.4183 8 17 12 21Z" stroke="#84CC16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const contactsData = [
    {
        title: "Registered Office:",
        address: "3rd Floor, Srivallis Corporate, Plot No. 290, SYN 33 34 PTO 39, Guttala Begumpet, Jubilee Hills, Hyderabad, Shaikpet, Telangana, 500033",
        tel: "+91 9391139986"
    },
    {
        title: "All investors communication and IEPF related queries to the Company can be addressed to:",
        name: "Ms. Yoshita Vora, Company Secretary and Compliance Officer",
        address: "Viyash Scientific Limited 301, 3rd Floor, Dosti Pinnacle, Plot No. E7, Road No.22 Wagle Industrial Estate, Thane (W), Mumbai - 400 604",
        tel: "+91-22-4111 4777",
        email: "investorrelations@viyash.com"
    },
    {
        title: "Registrar and Transfer Agent:",
        address: "KFin Technologies Limited Selenium Building, Tower-B, Plot No 31 & 32, Financial District, Nanakramguda, Serilingampally, Hyderabad, Rangareddy, Telangana, India - 500 032",
        tel: "+91-910 009 4099",
        email: "einward.ris@karvy.com",
        contact: "1800 309 4001 (Toll free)"
    },
    {
        title: "Authorized Key Managerial Personnel To Determine Materiality Of An Event/information:",
        name: "Dr. Haribabu Bodepudi, Managing Director and Group CEO",
        address: "Viyash Scientific Limited, 3rd Floor, Srivalli's Corporate, Plot No.290, Road No.6, Sy.No.33, 34P to 39, Guttala Begumpet, Jubilee Hills, Hyderabad, Shaikpet, Telangana, India-500033",
        tel: "+91 40 23635000",
        email: "investorrelations@viyash.com"
    },
    {
        title: "Authorized Key Managerial Personnel To Determine Materiality Of An Event/information:",
        name: "Mr. Rajaram Narayanan, Whole time Director and CEO- Animal Health",
        address: "Viyash Scientific Limited, 3rd Floor, Dosti Pinnacle, Plot No. E7, Road No 22, Wagle Industrial Estate, Thane (W), Mumbai - 400 604",
        tel: "+91 22 4111 4777",
        email: "investorrelations@viyash.com"
    },
    {
        title: "Authorized Key Managerial Personnel To Determine Materiality Of An Event/information:",
        name: "Mr. Ramakant Singani, Chief Financial Officer",
        address: "Viyash Scientific Limited, 3rd Floor, Srivalli's Corporate, Plot No.290, Road No.6, Sy.No.33, 34P to 39, Guttala Begumpet, Jubilee Hills, Hyderabad, Shaikpet, Telangana, India-500033",
        tel: "+91 40 23635000",
        email: "investorrelations@viyash.com"
    },
    
];

const InvestorContacts = () => {
    return (
        <div className="investor-contacts-page">
            <section className="fin-hero">
                <div className="fin-hero-content">
                    <h1>Investor Contacts</h1>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    {/* <p>Sequent Scientific Limited is India's leading animal health company.</p> */}
                </div>
            </section>

            <div className="contacts-content">
                <div className="contacts-grid">
                    {contactsData.map((contact, index) => (
                        <div key={index} className="contact-card">
                            <h3 className="contact-title">{contact.title}</h3>
                            <div className="contact-icon-wrapper">
                                <LocationIcon />
                            </div>
                            <div className="contact-details">
                                {contact.name && <p className="contact-name">{contact.name}</p>}
                                <p className="contact-address">{contact.address}</p>
                                {contact.tel && (
                                    <p className="contact-info">
                                        <strong>Tel No.:</strong> {contact.tel}
                                    </p>
                                )}
                                {contact.email && (
                                    <p className="contact-info">
                                        <strong>Email:</strong> <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                    </p>
                                )}
                                {contact.contact && (
                                    <p className="contact-info">
                                        <strong>Contact:</strong> {contact.contact}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default InvestorContacts;
